import { useRoutes } from "react-router-dom";
import { SupportRoutes } from "./routes/support.routes";
import { Authority, useAppLayout } from "@dataone/lib";
import { useEffect } from "react";
import { withAuth } from "../auth/helpers/hoc";

const SupportApp = () => {
  const element = useRoutes(SupportRoutes);

  useEffect(() => {
    useAppLayout.setState({ isSmartSearchVisible: false });
    useAppLayout.setState({ isResponseVisible: false });
  }, []);

  return <>{element}</>;
};

export default withAuth(SupportApp, [
  Authority.OG_SUBSCRIBER,
  Authority.OG_SUBSCRIBER_EX,
  Authority.OG_ADMIN,
]);
